import { decodeText } from '@/utils/decodeText';
import i18n from '@/locales/i18n';
import { mapState } from 'vuex';
import { UPDATE_MEMBER_COUNT, UPDATE_CONTROL_MEMBER_COUNT, UPDATE_LIKE_NUM, UPDATE_MESSAGE_COUNT } from '@/constants/mutation-types';


export default {
    data() {
        return {
            tim: null,
            isSdkReady: false,
            messageList: [], // 消息列表
            memberList: [], // 群成员列表
            muteUserIdList: [], // 被禁言的用户ID列表
            ws: {},
            callbacks: {},
            reroomid: ""
        };
    },
    computed: {
        ...mapState({
            userInfo: 'userInfo',
            roomId: 'roomId',
            roomName: 'roomName',
            liveStage: 'liveStage',
            // 房间人数
            memberCount: 'memberCount',
            // 控制人数
            controlMemberCount: 'controlMemberCount',
            // 点赞数
            likeNum: 'likeNum',
            // 消息数
            messageCount: 'messageCount',
        }),
        groupID() {
            return this.reroomid.toString();
        },
        muteUserIdKey() {
            return `TUIPusher_${this.sdkAppId}_${this.groupID}_${this.userInfo.userId}_muteUserId`;
        },
    },
    methods: {
        // ------------ 初始化及销毁相关 ----------
        // 初始化，创建tim实例
        async initTim() {

            imOpen();


            // this.handleTimEvents(); // 各种状态
            // this.loginTim(); // 登陆
        },
        // 使用 用户ID(userId) 和 签名串(userSig) 登录即时通信 IM
        async loginTim() {
            try {
                await this.tim.login({
                    userId: this.userInfo.userId,
                    userSig: this.userSig,
                });
            } catch (imError) {
                const errorInfo = i18n.t('tim.Failed to initialize streaming group') + i18n.t('tim.Refresh and try again');
                this.$message.error(errorInfo);
                console.error('im | login | failed', imError); // 登录失败的相关信息
            }
        },
        // 登出im
        async logout() {
            console.log('关闭 websockey')
            // wsService.imClose(true);
            try {
                // await this.tim.logout();
            } catch (imError) {
                // console.error('logout error:', imError);
            }
        },

        // ----------- 群组相关 ------------
        // 加入创建的直播群
        async joinGroup() {
            try {
                await this.tim.joinGroup({
                    groupID: this.groupID,
                    type: TIM.TYPES.GRP_AVCHATROOM,
                });
                this.getGroupMemberList();
            } catch (error) {
                console.error('joinGroup error:', error); // 申请加群失败的相关信息
            }
        },
        // 创建群组
        async createGroup() {
            try {
                await this.tim.createGroup({
                    type: TIM.TYPES.GRP_AVCHATROOM,
                    name: this.roomName,
                    groupID: this.groupID,
                });
            } catch (imError) {
                console.error('createGroup error:', imError);
                this.$message.error(i18n.t('tim.Failed to create streaming group')); // 创建群组失败的相关信息
            }
        },
        // 解散群组
        async dismissGroup(groupID) {
            return false
            try {
                await this.tim.dismissGroup(groupID);
            } catch (imError) {
                this.$message.error(i18n.t('tim.Failed to dismiss streaming group'));
                console.error('dismissGroup error:', imError); // 解散群组失败的相关信息
            }
        },
        // 判断群组是否存在
        async searchGroup() {
            try {
                // 判断群组是否存在
                await this.tim.searchGroupByID(this.groupID);
                // 修改群名称
                await this.tim.updateGroupProfile({
                    groupID: this.groupID,
                    name: this.roomName,
                });
                // 加入群组
                this.joinGroup();
                // 处理localStorage中存储的muteUserId数据
                const muteUserIdStorage = JSON.parse(localStorage.getItem(this.muteUserIdKey));
                if (muteUserIdStorage) {
                    const { time, value } = muteUserIdStorage;
                    if (Date.now() - time > 7 * 24 * 60 * 60 * 1000) {
                        localStorage.removeItem(this.muteUserIdKey);
                    } else {
                        this.muteUserIdList = value;
                    }
                }
            } catch (imError) {
                // 不存在的情况
                console.warn('searchGroupByID error:', imError); // 搜素群组失败的相关信息
                await this.createGroup();
                await this.joinGroup();
            }
        },

        // ----------- 群成员相关 ----------
        // 拉取直播群对应的群成员
        async getGroupMemberList() {
            try {
                const { data: { memberList } } = await this.tim.getGroupMemberList({
                    groupID: this.groupID,
                    count: 30,
                    offset: 0,
                });
                memberList.forEach((member) => {
                    console.log(member);
                    if (member.userId === this.userInfo.userId) { // 是否为主播
                        this.memberList.unshift({
                            ...member,
                            isMuted: false,
                        });
                    } else if (member.muteUntil * 1000 > Date.parse(new Date())) { // 仍被禁言
                        this.memberList.push({
                            ...member,
                            isMuted: true,
                        });
                    } else {
                        this.memberList.push({
                            ...member,
                            isMuted: false,
                        });
                    }
                });
            } catch (imError) {
                console.error('getGroupMemberProfile error:', imError);
            }
        },
        // 监听事件
        handleTimEvents() {
            // 登录成功后会触发 SDK_READY 事件，该事件触发后，可正常使用 SDK 接口
            this.tim.on(TIM.EVENT.SDK_READY, this.onReadyStateUpdate);
            // SDK NOT READT
            this.tim.on(TIM.EVENT.SDK_NOT_READY, this.onNotReadyStateUpdate);
            // 被踢出
            this.tim.on(TIM.EVENT.KICKED_OUT, this.onKickOut);
            // SDK内部出错
            this.tim.on(TIM.EVENT.ERROR, this.onError);
            // 收到新消息
            this.tim.on(TIM.EVENT.MESSAGE_RECEIVED, this.onTextMessageReceived);
        },
        async onReadyStateUpdate({ name }) {
            console.log(`onReadyStateUpdate ${name}`);
            const isSDKReady = name === TIM.EVENT.SDK_READY;
            if (isSDKReady) {
                this.isSdkReady = true;
                this.tim.getMyProfile();// 获取个人资料
                // 修改个人标配资料
                try {
                    await this.tim.updateMyProfile({
                        nick: this.userInfo.userName,
                        avatar: this.userInfo.userAvatar || '',
                        gender: TIM.TYPES.GENDER_FEMALE,
                        selfSignature: '',
                        allowType: TIM.TYPES.ALLOW_TYPE_ALLOW_ANY,
                    });
                } catch (imError) {
                    console.error('updateMyProfile error:', imError); // 更新资料失败的相关信息···
                }
                this.searchGroup();// 判断群组是否已经存在
            }
        },
        async onNotReadyStateUpdate({ name }) {
            console.log(`onReadyStateUpdate ${name}`);
        },
        // 收到的消息
        onTextMessageReceivedBak(event) {
            const messageList = event.data;
            messageList.forEach((message) => {
                // 监听加群消息
                if (message.type === TIM.TYPES.MSG_GRP_TIP && message.payload.operationType === TIM.TYPES.GRP_TIP_MBR_JOIN) {
                    this.handleJoinGroupTip(message);
                }
                // 监听退群消息
                if (message.type === TIM.TYPES.MSG_GRP_TIP && message.payload.operationType === TIM.TYPES.GRP_TIP_MBR_QUIT) {
                    this.handleQuitGroupTip(message);
                }
                // 监听文本消息
                if (message.type === TIM.TYPES.MSG_TEXT) {
                    this.handleMessageTip(message);
                }
            });
        },
        // ________________________________消息处理_______________________________
        onTextMessageReceived(event) {
            const messageList = event.data;
            messageList.forEach((message) => {
                // 群组会话
                if (message.conversationType === TIM.TYPES.CONV_GROUP) {
                    // 群提示消息
                    if (message.type === TIM.TYPES.MSG_GRP_TIP) {
                        // 加群消息 TIMGroupTipElem 1
                        if (message.payload.operationType === TIM.TYPES.GRP_TIP_MBR_JOIN) {
                            this.handleJoinGroupTip(message);
                        }
                        // 退群消息 TIMGroupTipElem 2
                        if (message.payload.operationType === TIM.TYPES.GRP_TIP_MBR_QUIT) {
                            this.handleQuitGroupTip(message);
                        }
                    }
                    // 监听文本消息 TIMTextElem
                    if (message.type === TIM.TYPES.MSG_TEXT) {
                        this.handleMessageTip(message);
                    }
                    // 自定义消息 点赞等
                    if (message.type === TIM.TYPES.MSG_CUSTOM) {
                        const payloadData = Number(message.payload.data);
                        const description = JSON.parse(message.payload.description);
                        const getPnum = description.pnum;
                        switch (payloadData) {
                            case 0:
                                console.log('接收到 点赞消息', message);
                                this.$store.commit(UPDATE_LIKE_NUM, parseInt(this.likeNum, 0) + 1);
                                break;
                            case 1:
                                console.log('用户收到主播发送的抽奖开始消息', message);
                                // 开始抽奖
                                // eventBus.emit('onStartLuckDrawAni', message.payload.description)
                                break;
                            case 2:
                                console.log('用户收到主播发送的中奖结果开始消息', message);
                                // 展示开奖结果
                                // eventBus.emit('onLuckDrawResult', JSON.parse(message.payload.description))
                                break;
                            case 3:
                                // 收到关闭直播间消息
                                // liveStore.setRefreshList(true)
                                // eventBus.emit('onCloseLiveFlagMsg')
                                break;
                            case 4:
                                // 收到控制人数
                                if (Number(description.roomId) === Number(this.roomId)) {
                                    if (parseInt(getPnum, 0) > 0) {
                                        this.$store.commit(UPDATE_CONTROL_MEMBER_COUNT, parseInt(this.controlMemberCount, 0) + parseInt(getPnum, 0));
                                    }
                                    if (parseInt(getPnum, 0) < 0) {
                                        if (parseInt(this.controlMemberCount, 0) + parseInt(getPnum, 0) > 0) {
                                            this.$store.commit(UPDATE_CONTROL_MEMBER_COUNT, parseInt(this.controlMemberCount, 0) + parseInt(getPnum, 0));
                                        } else {
                                            this.$store.commit(UPDATE_CONTROL_MEMBER_COUNT, 0);
                                        }
                                    }
                                }
                                break;
                            case 5:
                                // eventBus.emit('pushStartMsg')
                                break;
                        }
                    }
                }
                // c2c 会话
                // if (message.conversationType === TIM.TYPES.CONV_C2C) {
                //   let payloadData = Number(message.payload.data);
                // }

                // c2c消息 群主向新进入房间用户发送房间实时人数和点赞数
                // if(message)
            });
        },

        // ________________________________消息处理_______________________________


        // 关闭直播间
        async liveExit() {
            const payload = {
                data: '4',
                description: '',
                extension: '',
            };
            // this.sendCustomGroupMessage(payload);
        },
        // 监听到文本消息
        async handleMessageTip(message) {
            this.$store.commit(UPDATE_MESSAGE_COUNT, parseInt(this.messageCount, 0) + 1);
            this.messageList.push({
                nick: message.nick || message.from,
                content: message.payload.text,
                renderContent: decodeText(message.payload.text),
                userId: message.from,
                avatar: message.avatar,
                time: message.time,
            });
        },


        // 发送c2c消息
        async sendC2cMessage(payload, toUserId) {
            // 判断sdk的状态
            if (!this.isSdkReady) {
                console.log('sdk not ready');
                return;
            }
            const message = await this.tim.createCustomMessage({
                to: toUserId,
                conversationType: TIM.TYPES.CONV_C2C,
                needReadReceipt: false, // 已读回执
                payload,
                // priority:TIM.TYPES.MSG_PRIORITY_LOW
            });
            try {
                const imResponse = await this.tim.sendMessage(message);
                // 发送成功
                console.log(imResponse, '成功');
            } catch (imError) {
                // 发送失败
                console.error('sendMessage error:', imError);
            }
        },
        // 发送自定义消息
        async sendCustomGroupMessage(payload) {
            // 判断sdk的状态
            if (!this.isSdkReady) {
                console.log('sdk not ready');
                return;
            }
            const message = await this.tim.createCustomMessage({
                to: `${this.roomId}` + '',
                conversationType: TIM.TYPES.CONV_GROUP,
                needReadReceipt: false, // 已读回执
                payload,
            });
            try {
                const imResponse = await this.tim.sendMessage(message);
                // 发送成功
                console.log(imResponse, '成功');
            } catch (imError) {
                // 发送失败
                console.error('sendMessage error:', imError);
            }
        },
        // 监听到加群消息
        async handleJoinGroupTip(message) {
            if (message.payload.operatorID === this.userInfo.userId) {
                return;
            }
            const { avatar, nick, payload: { operatorID } } = message;
            this.memberList = this.memberList.filter(memberInfo => memberInfo.userId !== operatorID);
            const newUserInfo = {
                avatar,
                userId: operatorID,
                nick,
                isMuted: this.muteUserIdList.indexOf(operatorID) >= 0,
            };
            this.memberList.push(newUserInfo);
            // 更新直播间人数
            this.$store.commit(UPDATE_MEMBER_COUNT, parseInt(this.memberCount, 0) + 1);
            // 主播向新加入房间的用户发送 实时房间人数 和点赞数
            const descriptionData = {
                mc: this.memberCount, // 房间人数
                cmc: this.controlMemberCount, // 控制人数
                lc: this.likeNum, // 点赞数
                mesc: this.messageCount, // 消息数
            };
            const payload = {
                data: '1',
                description: JSON.stringify(descriptionData),
                extension: '',
            };
            console.log('主播向 新加入用户发送 点赞数和人数', descriptionData);
            this.sendC2cMessage(payload, message.payload.operatorID.toString());
        },
        // 监听到退群消息
        async handleQuitGroupTip(message) {
            this.memberList = this.memberList.filter(member => member.userId !== message.payload.operatorID);
            console.log('监听到退群消息', message);
            // 房间人数-1
            if (this.memberCount > 1) {
                this.$store.commit(UPDATE_MEMBER_COUNT, parseInt(this.memberCount, 0) - 1);
            }
        },
        // 发送消息
        async sendMessage(msgText) {
            // 判断sdk的状态
            if (!this.isSdkReady) {
                console.log('sdk not ready');
                return;
            }
            // 创建消息并发送到对应群组
            const message = {
                from: this.userInfo.userId,
                createTime: new Date().getTime(),
                cmd: 11,
                groupId: this.reroomid,
                chatType: 1,
                msgType: 0,
                content: { avatar: this.userInfo.userAvatar, nick: this.userInfo.userName, text: msgText }
            }
            console.log('准备发送的信息', message)
            try {
                this.imSend(message);
                // 发送成功
            } catch (imError) {
                // 发送失败
                console.error('sendMessage error:');
            }


            // const message = await this.tim.createTextMessage({
            //     to: this.groupID,
            //     conversationType: TIM.TYPES.CONV_GROUP,
            //     payload: {
            //         text: msgText,
            //     },
            // });
            // try {
            //     const imResponse = await this.tim.sendMessage(message);
            //     // 发送成功
            //     console.log(imResponse, '成功');
            // } catch (imError) {
            //     // 发送失败
            //     console.error('sendMessage error:', imError);
            // }
            // 放入消息列表
            this.messageList.push({
                nick: this.userInfo.userName || '',
                content: msgText,
                renderContent: decodeText(msgText),
                userId: this.userInfo.userId,
                time: Number(Date.now().toString()
                    .substr(0, 10)),
            });
        },
        // 设置禁言
        async setGroupMemberMuteTime({ userId, muteTime }) {
            try {
                await this.tim.setGroupMemberMuteTime({
                    groupID: this.groupID,
                    userId,
                    muteTime, // 设为0，则表示取消禁言
                });
                const member = this.memberList.find(item => item.userId === userId);
                member.isMuted = muteTime !== 0;
                if (muteTime > 0 && this.muteUserIdList.indexOf(userId) < 0) {
                    this.muteUserIdList.push(userId);
                } else {
                    this.muteUserIdList = this.muteUserIdList.filter(muteUserID => muteUserID !== userId);
                }
                localStorage.setItem(this.muteUserIdKey, JSON.stringify({
                    time: Date.now(),
                    value: this.muteUserIdList,
                }));
            } catch (imError) {
                console.error('setGroupMemberMuteTime error:', imError); // 禁言失败
            }
        },
        // 错误
        onError() {

        },
        // 被踢出
        onKickOut() {

        },

        handleOpen() {
            console.log('WebSocket连接已建立');
            if (this.callbacks.imOpen) {
                this.callbacks.imOpen.forEach((cb) => cb());
            }
        },
        handleMessage(event) {
            const data = JSON.parse(event.data);
            if (this.callbacks.message) {
                this.callbacks.message.forEach((cb) => cb(data));
            }
        },
        handleError(error) {
            console.error('WebSocket错误:', error);
            if (this.callbacks.error) {
                this.callbacks.error.forEach((cb) => cb(error));
            }
        },

        handleClose() {
            console.log('WebSocket连接已关闭');
            if (this.callbacks.imClose) {
                this.callbacks.imClose.forEach((cb) => cb());
                if (!this.options.reconnectTimeout) {
                    this.reconnect();
                }
            }
        },
        imOpen() {
            const options = {
                url: `${process.env.VUE_APP_IM_URL}?userId=${this.userInfo.userId}&password=123&nick=${this.userInfo.userName}&groupId=${this.reroomid}&groupName=群name&avatar=${this.userInfo.userAvatar}`
            }
            console.log('wsurl', options)
            this.ws = new WebSocket(options.url)
            console.log('imOpen ws ====================', this.ws)
            this.ws.addEventListener('open', this.handleOpen);
            this.ws.addEventListener('message', this.handleMessage);
            this.ws.addEventListener('error', this.handleError);
            this.ws.addEventListener('close', this.handleClose);
        },
        imClose(isActiveClose) {
            if (this.ws) {
                this.ws.close();
                if (!isActiveClose) {
                    setTimeout(() => this.reconnect(), 5000);
                }
            }
        },
        reconnect() {
            this.imOpen();
        },

        imOn(event, callback) {
            if (!this.callbacks[event]) {
                this.callbacks[event] = [];
            }
            this.callbacks[event].push(callback);
        },
        imSend(data) {
            if (this.ws && this.ws.readyState === WebSocket.OPEN) {
                this.ws.send(JSON.stringify(data));
            } else {
                console.warn('尝试发送消息时WebSocket未连接');
            }
        },

        sendCustomGroupMessage(payload) {
            // 判断sdk的状态
            if (!this.isSdkReady) {
                console.log('sdk not ready');
                return;
            }
            const message = {
                from: this.userInfo.userId,
                createTime: new Date().getTime(),
                cmd: payload.cmd,
                groupId: this.reroomid,
                chatType: 1,
                msgType: 0,
                content: payload
            }
            console.log('发送点赞消息', payload)
            try {
                // const imResponse = await tim.sendMessage(message);
                this.imSend(message);
                // 发送成功
            } catch (imError) {
                // 发送失败
                console.error('sendMessage error:', imError);
            }



            // let tmpmsg: ImReceiveBaseMsgTypeVO = {
            //     from: message.from,
            //     nick: message.nick || message.from,
            //     content: message.payload,
            //     renderContent: message.payload,
            //     userID: message.from,
            //     avatar: message.avatar,
            //     payload: message.payload,
            //     time: Number(Date.now().toString()
            //         .substr(0, 10)),
            // }

            // //发送消息成功后 发送消息上屏信号
            // eventBus.emit('likeMsgEvent', tmpmsg)

        },
        COMMAND_GET_USER_REQ() {
            // onlineUserCmd = "{\"cmd\":17,\"type\":\"0\",\"userId\":\""+userId+"\"}";
            const onlineUserCmd = {
                cmd: 17,
                type: 0,
                userId: this.userInfo.userId,
                groupId: this.reroomid
            }
            // this.$eventBus.$emit('wsReady');
            this.isSdkReady = true;
            console.log('isSdkReady ready--------------------', onlineUserCmd)
            this.imSend(onlineUserCmd);

        },
        COMMAND_JOIN_GROUP_NOTIFY_RESP(message) {
            //新加入房间用户 上屏提示 欢迎加入房间
            console.log('加入房间message', message)
            if (message.user.userId === this.userInfo.userId) {
                return;
            }
            this.memberList = this.memberList.filter(memberInfo => memberInfo.userId !== this.userInfo.userId);
            const newUserInfo = {
                avatar: message.user.avatar,
                userId: message.user.userId,
                nick: message.user.nick,
                isMuted: this.muteUserIdList.indexOf(message.user.userId) >= 0,
            };
            this.memberList.push(newUserInfo);
            // 更新直播间人数
            this.$store.commit(UPDATE_MEMBER_COUNT, parseInt(this.memberCount, 0) + 1);
            // 主播向新加入房间的用户发送 实时房间人数 和点赞数
            // const descriptionData = {
            //     mc: this.memberCount, // 房间人数
            //     cmc: this.controlMemberCount, // 控制人数
            //     lc: this.likeNum, // 点赞数
            //     mesc: this.messageCount, // 消息数
            // };
            // const payload = {
            //     data: '1',
            //     description: JSON.stringify(descriptionData),
            //     extension: '',
            // };
            // console.log('主播向 新加入用户发送 点赞数和人数', descriptionData);
            // this.sendC2cMessage(payload, message.payload.operatorID.toString());
            // liveStore.setMemberCount(1)
        },
        COMMAND_EXIT_GROUP_NOTIFY_RESP(message) {
            this.memberList = this.memberList.filter(member => member.userId !== message.data.user.userId);
            console.log('监听到退群消息', message);
            // 房间人数-1
            if (this.memberCount > 1) {
                this.$store.commit(UPDATE_MEMBER_COUNT, parseInt(this.memberCount, 0) - 1);
            }
        },
        COMMAND_CHAT_REQ(message) {
            message = message.data
            if (message.from == this.userInfo.userId) {
                return false
            }
            console.log('解析消息 content_________________', message.content)
            let content = JSON.parse(message.content)
            console.log('解析消息 content', content)
            if (undefined == content.text.data) {
                this.$store.commit(UPDATE_MESSAGE_COUNT, parseInt(this.messageCount, 0) + 1);
                console.log('测试================>>>>>>>>>>>>>>>1', { text: content.text })
                console.log('测试================>>>>>>>>>>>>>>>2', decodeText(content.text))
                this.messageList.push({
                    nick: content.nick || message.from,
                    content: content.text,
                    renderContent: decodeText(content.text),
                    userId: message.from,
                    avatar: content.avatar,
                    time: Number(Date.now().toString()
                        .substr(0, 10)),
                });
            }

            if (undefined != content.text.data) {


            }




        },
        COMMAND_GET_USER_RESP(message) {
            message = message.data
            const groupInfo = message.groups[0]
            console.log('COMMAND_GET_USER_RESP message', message)
            console.log('点赞数', groupInfo.likeNum)
            console.log('在线人数', groupInfo.online)
            // 初始在线人数
            this.$store.commit(UPDATE_MEMBER_COUNT, parseInt(groupInfo.online, 0));
            this.$store.commit(UPDATE_LIKE_NUM, parseInt(groupInfo.likeNum, 0));
            console.log('初始点赞数',this.likeNum)
        },
        COMMAND_LIKE_MESSAGE_RESP(message) {
            message = message.data
            if (message.from == this.userInfo.userId) {
                return false
            }
            this.$store.commit(UPDATE_LIKE_NUM, parseInt(this.likeNum, 0) + 1);
            console.log('收到点赞消息 发送结果', message)
            console.log('收到点赞消息后 点赞数',this.likeNum)
        },
        onSendCustomGroupMessage(payload) {
            if (!this.isSdkReady) {
                console.log('sdk not ready');
                return;
            }
            const message = {
                from: this.userInfo.userId,
                createTime: new Date().getTime(),
                cmd: payload.cmd,
                groupId: this.reroomid,
                chatType: 1,
                msgType: 0,
                content: payload
            }
            console.log('发送点赞消息', payload)
            try {
                // const imResponse = await tim.sendMessage(message);
                this.imSend(message);
                // 发送成功
            } catch (imError) {
                // 发送失败
                console.error('sendMessage error:', imError);
            }

        }
    },
    mounted() {
        this.reroomid = this.roomId + "_" + process.env.VUE_APP_LIVEPREFIX
        this.imOpen()
        this.imOn('message', (data) => {
            console.log('websocket im on', data)
            switch (data.command) {
                case 3:
                    // console.log('用户下线')
                    break;
                case 6:
                    //登录成功
                    this.COMMAND_GET_USER_REQ()
                    break;
                case 9:
                    // 用户加入
                    this.COMMAND_JOIN_GROUP_NOTIFY_RESP(data)
                    break;
                case 10:
                    // 退出群组通知
                    this.COMMAND_EXIT_GROUP_NOTIFY_RESP(data);
                    break;
                case 11:
                    // 聊天
                    this.COMMAND_CHAT_REQ(data);
                    break;
                case 18:
                    // 获取所有在线用户信息
                    this.COMMAND_GET_USER_RESP(data)
                    break;
                case 22:
                    // 收到点赞消息
                    this.COMMAND_LIKE_MESSAGE_RESP(data);
                    break;

            }
        })
        let that = this
        this.$eventBus.$on('onSendCustomGroupMessage', (payload) => {
            that.onSendCustomGroupMessage(payload)
        });
    },
    beforeDestroy() {
        console.log('销毁监听======>>>>>>>>>>>>>onSendCustomGroupMessage')
        this.$eventBus.$off('onSendCustomGroupMessage', this.onSendCustomGroupMessage);
    }

};
